import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Constants for Japanese text
const JAPANESE_TEXT = {
  NO_INSIGHTS: 'AI分析・洞察なし',
  AI_INSIGHTS: 'AI分析・洞察',
};

const RightSections = ({ attachments, onItemClick }) => {
  // Separate items based on whether they have AI insights
  const itemsWithInsights = [];
  const itemsWithoutInsights = [];

  attachments.forEach((item) => {
    const { result } = item;
    const insights = result.answer.insights;

    // Check if item has meaningful AI insights
    const hasInsights =
      insights &&
      insights.trim() !== '' &&
      insights !== 'No insights available' &&
      insights !== '記載なし';

    if (hasInsights) {
      itemsWithInsights.push(item);
    } else {
      itemsWithoutInsights.push(item);
    }
  });

  const renderItemWithInsights = (item) => {
    const { filename, result, id } = item;

    return (
      <div
        key={id}
        id={`right-item-${id}`}
        onClick={() => onItemClick && onItemClick(id)}
        style={{
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '16px',
          backgroundColor: '#fafafa',
          cursor: 'pointer',
        }}>
        <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>
          {result.answer.item || filename}
        </div>
        <div style={{ lineHeight: '1.5', fontSize: '0.9rem' }}>
          {result.answer.insights}
        </div>
      </div>
    );
  };

  const renderItemWithoutInsights = (item) => {
    const { filename, result, id } = item;

    return (
      <div
        key={id}
        id={`right-item-${id}`}
        onClick={() => onItemClick && onItemClick(id)}
        style={{
          border: '1px solid #f0f0f0',
          borderRadius: '4px',
          padding: '12px',
          marginBottom: '8px',
          backgroundColor: '#ffffff',
          cursor: 'pointer',
        }}>
        <div style={{ fontWeight: 'bold', color: '#666' }}>
          {result.answer.item || filename}
        </div>
      </div>
    );
  };

  return (
    <div style={{ padding: '0 16px' }}>
      {/* Display items with insights individually */}
      {itemsWithInsights.map(renderItemWithInsights)}

      {/* Display items without insights in a collapsible accordion */}
      {itemsWithoutInsights.length > 0 && (
        <Accordion
          style={{
            marginBottom: '16px',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            backgroundColor: '#f8f8f8',
          }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="no-insights-content"
            id="no-insights-header"
            style={{
              backgroundColor: '#f0f0f0',
              borderRadius: '8px 8px 0 0',
            }}>
            <div style={{ fontWeight: 'bold', color: '#666' }}>
              {JAPANESE_TEXT.NO_INSIGHTS} ({itemsWithoutInsights.length}件)
            </div>
          </AccordionSummary>
          <AccordionDetails style={{ padding: '8px' }}>
            {itemsWithoutInsights.map(renderItemWithoutInsights)}
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
};

RightSections.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.object).isRequired,
  onItemClick: PropTypes.func,
};

export default RightSections;
